import { ChildrenProp } from '@/common/types_and_interfaces.ts'

export const ActionBar = ({ children }: ChildrenProp) => {
  return <div className="flex justify-end">{children}</div>
}
